import { Pipe, PipeTransform } from '@angular/core'
import { isObject } from 'lodash'

@Pipe({
  name: 'join',
  standalone: false,
})
export class JoinPipe implements PipeTransform {
  transform (input: any[], key: string, separator = ', '): string {
    if (!Array.isArray(input)) {
      return input
    }

    return input
      .map((item: Record<string, any> | string) => {
        if (typeof item === 'string') {
          return item
        }

        if (this.isObject(item)) {
          return item[key]
        }
      })
      .filter(Boolean)
      .join(separator)
  }

  private isObject (value: any): value is Record<string, any> {
    return isObject(value)
  }
}
